import { render, staticRenderFns } from "./PesquisadorForm.vue?vue&type=template&id=4c4a7b86&"
import script from "./PesquisadorForm.vue?vue&type=script&lang=js&"
export * from "./PesquisadorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports